import { useCallback } from "react";

import type { Plan } from "@/lib/gql/__generated__/graphql";

import { TableRow } from "@/components/ui/table/table";

import { PlanListPageTableItem } from "./item";

type Props = {
	plan: Plan;
	editPlanPagePath: string;

	onTransitionToEdit: () => void;
	onDeletePlan: () => Promise<void>;
	showScConnectedColumn: boolean;
};

export const PlanListPageTableDefaultItem = ({
	plan,
	editPlanPagePath,
	onTransitionToEdit,
	onDeletePlan,
	showScConnectedColumn,
}: Props) => {
	const handleClick = useCallback(() => {
		onTransitionToEdit();
	}, [onTransitionToEdit]);

	return (
		<TableRow className="hover:cursor-pointer" onClick={handleClick}>
			<PlanListPageTableItem
				onDeletePlan={onDeletePlan}
				onTransitionToEdit={onTransitionToEdit}
				plan={plan}
				editPlanPagePath={editPlanPagePath}
				showScConnectedColumn={showScConnectedColumn}
			/>
		</TableRow>
	);
};

PlanListPageTableDefaultItem.displayName = "PlanListPageTableDefaultItem";
